const components = [
  { name: 'TablePage', component: () => import('@/components/base/TablePage.vue') }, // table基础组件 加分页
  { name: 'UploadImage', component: () => import('@/components/base/UploadImage.vue') }, // 上传图片组件
  { name: 'Panel', component: () => import('@/components/base/Panel.vue') }, // 基础面板
  { name: 'CtnPannel', component: () => import('@/components/base/CtnPannel.vue') }, // 创建面板
  { name: 'InputNumber', component: () => import('@/components/base/InputNumber.vue') }, // 钱输入框
  { name: 'EshopTitle', component: () => import('@/components/base/EshopTitle.vue') }, // 标题

]

export default {
  install(Vue) {
    components.forEach(com => {
      Vue.component(com.name, com.component)
    })
  }
}